import { Directive, HostListener, Input, Optional } from '@angular/core';

import { DropdownBase } from './dropdown.base';

@Directive({ selector: '[dpwClose]' })
// directive for Dropdown to close it on click
export class MenuItemDirective {
  @Input()
  closeMode?: 'all';

  constructor(@Optional() private dropdown?: DropdownBase) {}

  @HostListener('click')
  onClick(): void {
    this.dropdown?.scheduleClose({ closeAll: this.closeMode === 'all' });
  }
}
